import * as actionTypes from "../actions/types";
import produce from "immer";

const initialState = {
  isUpdateMobileNo: false,
};

let newData = [];
export default produce((draft = initialState, action) => {
  const { type, payload } = action;
  console.log("updateMobileNoReducer", payload);
  switch (type) {
    case actionTypes.OPEN_UPDATE_MOBILE_NO:
      draft.isUpdateMobileNo = true;
      return draft;
    case actionTypes.CLOSE_UPDATE_MOBILE_NO:
      draft.isUpdateMobileNo = false;
      return draft;
    default:
      return draft;
  }
});
